import { ReactElement } from 'react';

import { useStoreActions } from '~/store/hooks';
import { IYearMonth } from '~/utils/date/date';
import { useApiRequest } from '~/hooks/api';
import { IMedicaidPlanClient } from '~/services/api/medicaidPlan/types';

import MonthRecord from './MonthRecord';

interface IActivePlanMonthProps {
  client: IMedicaidPlanClient;
  selected: IYearMonth;
}

const ActivePlanMonth = ({ client, selected }: IActivePlanMonthProps): ReactElement => {
  const { onGetMonthlyTotals } = useStoreActions(actions => actions.communityEngagement);

  const { isLoading, data: record } = useApiRequest(
    ({ signal }) =>
      onGetMonthlyTotals({ ...client, year: selected.year, month: selected.month, signal }),
    {
      initialLoading: true,
      dependencies: [client, selected.year, selected.month],
    },
  );

  return (
    <MonthRecord
      selected={selected}
      isLoading={isLoading}
      record={record}
      archivedEntries={record?.archivedEntries}
      archivedExemptions={record?.archivedExemptions}
    />
  );
};

export default ActivePlanMonth;
